import { useState } from 'react';
import { Link as LinkIcon, X } from 'lucide-react';

export default function AddUrlModal({ onClose, onAdd }) {
  const [url, setUrl] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async () => {
    if (!url.match(/^https?:\/\//i)) {
      setError('URL must start with http:// or https://');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await onAdd(url, name || url);
      onClose();
    } catch (err) {
      setError(err?.response?.data?.detail || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="card-title">Add a URL source</div>
          <button className="icon-btn" onClick={onClose} aria-label="Close"><X size={16} /></button>
        </div>
        <input
          className="step-subject"
          value={url}
          placeholder="https://acme.io/pricing"
          onChange={(e) => setUrl(e.target.value)}
        />
        <input
          className="step-subject"
          value={name}
          placeholder="Display name (e.g. Acme pricing)"
          onChange={(e) => setName(e.target.value)}
        />
        <div className="card-row muted">
          <LinkIcon size={12} /> The agent will scrape this page once. Re-add to refresh.
        </div>
        {error && <div className="card-row error-text">{error}</div>}
        <div className="card-actions">
          <button className="primary-btn" onClick={onSubmit} disabled={busy || !url}>
            {busy ? 'Adding…' : 'Add'}
          </button>
          <button className="text-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
